var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"videoPlayer"}},[_c('video',{attrs:{"id":_vm.id,"controls":"","autoplay":""},domProps:{"muted":_vm.muted}}),(_vm.showIntranetText)?_c('span',{staticClass:"intranet"},[_vm._v("仅支持内网环境")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }